export const DEFAULT_ENTITY_TYPE = "pcr";
